import { defineStore } from "pinia";
import type { IUserLogged } from "~/interfaces/IUserLogged";

export const useAuthorizedDeviceStore = defineStore("authorizedDevice", {
  state: () => ({
    user: null as IUserLogged | null,
    deviceToken: null as string | null,
  }),

  getters: {
    isDeviceVerified: (state) => state.user?.authorized_device === true,
    hasDeviceToken: (state) => !!state.deviceToken,
  },

  actions: {
    loadUserFromLocalStorage() {
      const raw = localStorage.getItem("customer");
      const rawToken = localStorage.getItem("device_token");
      if (raw) {
        this.user = JSON.parse(raw);
      }
      if (rawToken) {
        this.deviceToken = rawToken;
      }
    },

    markDeviceAsVerified(deviceToken: string) {
      if (this.user) {
        this.user.authorized_device = true;
        localStorage.setItem("customer", JSON.stringify(this.user));
        localStorage.setItem("device_token", deviceToken);
        this.deviceToken = deviceToken;
      }
    },
  },
});
